// Browser-safe logger (the original Loggy in connect/ used node fs which doesn't
// work in the Vue 3 SPA). API kept identical so the port is 1:1.

export interface ILog {
    debug(message: string, ...args: unknown[]): void;
    info(message: string, ...args: unknown[]): void;
    warning(message: string, ...args: unknown[]): void;
    error(message: string, ...args: unknown[]): void;
}

enum Type {
    DEBUG = 1,
    INFO,
    WARNING,
    ERROR,
}

function TypeToString(type: Type): string {
    switch (type) {
        case Type.DEBUG: return 'DEBUG';
        case Type.INFO: return 'INFO';
        case Type.WARNING: return 'WARNING';
        case Type.ERROR: return 'ERROR';
    }
    return 'UNKNOWN';
}

export class Loggy implements ILog {
    private static readonly defaultLog = new Loggy();
    public static Log(): Loggy {
        return Loggy.defaultLog;
    }

    debug(message: string, ...args: unknown[]) { this._log(Type.DEBUG, message, ...args); }
    info(message: string, ...args: unknown[]) { this._log(Type.INFO, message, ...args); }
    warning(message: string, ...args: unknown[]) { this._log(Type.WARNING, message, ...args); }
    error(message: string, ...args: unknown[]) { this._log(Type.ERROR, message, ...args); }

    _log(type: Type, message: string, ...args: unknown[]) {
        const date = new Date();
        const time = `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
        const prefix = `[${TypeToString(type)}][${time}]`;
        // Keep args in console as separate values so DevTools can drill in
        // (the connect/loggy version joined them into a string — losing object detail).
        // eslint-disable-next-line no-console
        console.log(prefix, message, ...args);
    }
}

export function Log(): Loggy {
    return Loggy.Log();
}
